// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,600,700&display=swap);"]);
// Module
exports.push([module.id, ".CreditBox{max-width:331px;height:100%;width:100%;max-height:340px;min-height:320px;background-image:url(/assets/images/offers/credit-graphic.webp);background-repeat:no-repeat;background-size:contain;background-position:center bottom -12px}.CreditBox .CreditNumber{margin-top:27px;font-size:56px;font-weight:700}.CreditBox .CreditText{font-size:20px;font-weight:700}\n", ""]);
// Exports
module.exports = exports;
